<script setup lang="ts">
import { nextTick, ref } from "vue";
import { locale } from "../../locale";
import { Instance, createPopper } from "@popperjs/core";
import useHover from "../../composables/useHover";
const tooltip = ref<HTMLElement | null>(null);
const btn = ref<HTMLElement | null>(null);
const state = ref(false);
let popper: Instance | null = null;
const reset = () => {
  popper?.destroy();
  state.value = false;
};
const uh = useHover(btn, (hov) => {
  if (hov) {
    setTimeout(() => {
      if (uh.state.value) {
        showMessage();
      }
    }, 1000);
  } else {
    hideMessage();
  }
});
function showMessage() {
  if (!state.value) {
    state.value = true;
    nextTick(() => {
      popper = createPopper(
        btn.value as HTMLElement,
        tooltip.value as HTMLElement,
        {
          placement: "bottom",
          strategy: "fixed",
          modifiers: [{ name: "offset", options: { offset: [0, 5] } }],
        },
      );
    });
  }
}
function hideMessage() {
  popper?.destroy();
  state.value = false;
}
defineExpose({
  reset,
});
</script>
<template>
  <div class="wrapper">
    <div ref="btn" class="spinner-wrapper">
      <span class="spinner-summary"></span>
    </div>
    <div v-if="state" class="tooltip" ref="tooltip">
      {{ locale.downloadRecordSummaryLoading }}
    </div>
  </div>
</template>
<style scoped>
svg {
  flex-shrink: 0;
  cursor: pointer;
}
.wrapper {
  display: flex;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
.tooltip {
  max-width: 450px;
  overflow-wrap: break-word;
  background-color: rgba(41, 41, 41, 0.85);
  color: #ececec;
  border-radius: 7px;
  padding: 8px 15px;
}

.spinner-wrapper {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-summary {
  width: 16px;
  height: 16px;
  border: 1.5px solid #747474;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation-summary 1s linear infinite;
}

@keyframes rotation-summary {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
